import { useEffect, useRef } from 'react';

import LoadingStatus from '@libs/loading-status';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * 로딩 상태가 성공, 실패로 변경됐을 때 콜백을 실행시켜주기 위한 커스텀 훅
 * @example
 * function Example() {
 *   const status = useSelector(getLoadingStatus);
 *
 *   useLoadingStatusChangedCallback(
 *     status,
 *     useCallback(() => {
 *       // status가 PENDING -> SUCCEEDED로 변경시 실행되는 콜백
 *     }, []),
 *     useCallback(() => {
 *       // status가 PENDING -> FAILED로 변경시 실행되는 콜백
 *     }, [])
 *   );
 * }
 */
function useLoadingStatusChangedCallback(
  status: LoadingStatus,
  onSucceeded: (...args: any[]) => any,
  onFailed?: (...args: any[]) => any
): void {
  const lastLoadingStatus = useRef(status);

  useEffect(() => {
    if (lastLoadingStatus.current === LoadingStatus.PENDING) {
      if (status === LoadingStatus.SUCCEEDED) {
        onSucceeded();
      } else if (status === LoadingStatus.FAILED && onFailed) {
        onFailed();
      }
    }
    lastLoadingStatus.current = status;
  }, [onFailed, onSucceeded, status]);
}

export default useLoadingStatusChangedCallback;
